import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "react-responsive";
import {sendProgramToExpertise,
  sendProgramToPublication,
  sendProgramToDevelop,
  approveProgramExpertise,
  approveProgramPublication,
  rejectProgramExpertise,
  rejectProgramPublication} from "../../../Program/store/send";
import Alert from '@material-ui/lab/Alert';

import {
  getModuleInformationAction,
  getEducationFormAction,
  getTrialFormAction,
  updateModuleInformationAction,
  addNewModuleInformationAction,
  getModuleCardAction,
  getModulePurposeAction,
  getModuleResultSkillAction,
  changeModuleResultSkillAction,
  deleteModuleAction,
  changeModuleInformationAction,
  changeModulePurposeAction,
  getModuleDigitalUsageAction,
  changeModuleDigitalUsageAction,
  getModuleAbilityAction,
  addModuleCardLogoAction,
  deleteModuleCardLogoAction,
  addModuleProgramAction,
  deleteModuleProgramAction,
  getAllModuleVolumeAction,
  getAllModuleThemeVolumeAction,
  getAllModuleAbilityThemeAction,
  getAllModuleLessonThemeAction,
  getAllLessonTypeAction,
  getAllResourceListAction,
  getAllRoomTypesListAction,
  getAllModuleRoomListAction,
  getAllModuleResourceListAction,
  getAllResourceTypeListAction,
  getAllModuleReferenceListAction,
  getAllModuleSiteListAction,
  getModuleScheduleAction,
  saveAllModuleScheduleAction,
  getModuleEstimateAction,
  changeModuleEstimateAction,
  getAllModuleCriterionListAction,
  getAllModuleCompilersAction
} from "../../store/actions";
import { getSpecialities } from "../../../../Dict/Skills/Speciality/store/actions";
import { getSkillAllAction } from "../../../../Dict/Skills/Skill/store/actions";
import { getOrganizations } from "../../../../ManageOOP/Resources/Person/store/actions";

import Breadcrumbs from "../../../../ui/Breadcrumbs";

import Navbar from "./Navbar";

import DeleteConfirmationModal from "../../../../ui/DeleteConfirmationModal";
import Progress from "../../../../ui/Progress";

import BasicInfo from "./Tabs/BasicInfo";
import Purpose from "./Tabs/Purpose";
import ResultSkill from "./Tabs/ResultSkill";
import ModuleRequirements from "./Tabs/ModuleRequirements";
import DigitalTrainingMaterials from "./Tabs/DigitalTrainingMaterials";
import ThematicPlan from "./Tabs/ThematicPlan";
import TrainingProgram from "./Tabs/TrainingProgram";
import CalendarSchedule from "./Tabs/CalendarSchedule";
import TechnicalConditions from "./Tabs/TechnicalConditions";
import MainBooks from "./Tabs/Books/MainBooks";
import AditionalBooks from "./Tabs/Books/AditionalBooks";
import Periodicals from "./Tabs/Books/Periodicals";
import ElectronicResource from "./Tabs/ElectronicResource";
import QualityControl from "./Tabs/QualityСontrol";
import Compilers from "./Tabs/Compilers";

import InfoDrawer from "../../../../ui/InfoDrawer";
import ModuleInfoDrawer from "../ModuleInfoDrawer";

import Tabs from "../../../../ui/Tabs";
import Box from "../../../../ui/Box";
import ApproveModal from "../../../Program/pages/ProgramEdit/components/ApproveModal";
import initMobileViewport from "devextreme/mobile/init_mobile_viewport";

const items = [
  {
    label: "Конструктор КиОП",
    link: "/work/app/constructor"
  },
  {
    label: "Конструктор модулей",
    link: "/work/app/constructor/modules"
  }
];

const tabitems = [
  { number: 0, caption: "Основные сведения" },
  { number: 1, caption: "Цели реализации модуля" },
  {
    number: 2,
    caption: "Характеристика новых профессиональных и общих компетенций"
  },
  { number: 3, caption: "Требования к результатам освоения модуля" },
  { number: 4, caption: "Цифровые учебные материалы" },
  { number: 5, caption: "Учебно-тематический план" },
  { number: 6, caption: "Учебная программа модуля" },
  { number: 7, caption: "Календарный учебный график" },
  { number: 8, caption: "Материально -технические условия реализации модуля" },
  { number: 9, caption: "Основная литература" },
  { number: 10, caption: "Дополнительная литература" },
  { number: 11, caption: "Переодические издания" },
  { number: 12, caption: "Электронные ресурсы" },
  { number: 13, caption: "Оценка качества освоения модуля" },
  { number: 14, caption: "Составители" }
];

const useStyles = makeStyles({
  content: {
    width: "calc(100% - 300px)",
    boxSizing: "border-box"
  },
  nav: {
    marginBottom: 10
  },
  root: {
    display: "flex",
    "& .MuiInputLabel-root": {
      fontSize: "13px",
      letterSpacing: "0.2px",
      whiteSpace: "nowrap"
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingRight: "0px"
    },
    "& Input": {
      fontSize: "12px",
      lineHeight: "16px"
    },
    "& Textarea": {
      fontSize: "12px",
      lineHeight: "16px"
    }
  },

  tab: {
    textAlign: "left",
    fontSize: "14px",
    lineHeight: "18px",
    color: "#596E79",

    "& .MuiTab-wrapper": {
      textTransform: "initial",
      alignItems: "flex-start"
    },
    "&.Mui-selected": {
      background: "#F2F2F2"
    }
  },
  progress: {
    width: "100%",
    display: "flex",
    justifyContent: "center"
  }
});

const ModuleEdit = props => {
  const classes = useStyles();
  const [deleteConfimationOpen, setDeleteConfimationOpen] = useState(false);
  const [saveModule, setSaveModule] = useState(false);

  useEffect(() => {
    const id = props.match.params.id;
    props.getSkillList();
    props.getSpecialitiesList();
    props.getEducationForm();
    props.getTrialForm();
    props.getAllLessonType();
    props.getAllResourceList();
    props.getAllRoomTypesList();
    props.getAllResourceTypeList();
    props.getAllModuleRoomList(id);
    props.getModuleInformation(id);
    props.getModulePurpose(id);
    props.getModuleResultSkill(id);
    props.getModuleAbility(id);
    props.getModuleDigitalUsage(id);
    props.getAllModuleVolume(id);
    props.getAllModuleThemeVolume(id);
    props.getAllModuleAbilityTheme(id);
    props.getAllModuleLessonTheme(id);
    props.getAllModuleResourceList(id);
    props.getAllModuleReferenceList(id);
    props.getAllModuleSiteList(id);
    props.getModuleSchedule(id);
    props.getModuleEstimate(id);
    props.getAllModuleCriterionList(id);
    props.getAllModuleCompilers(id);
    props.getOrganizationsList();
  }, []);

  const changeModuleInformation = (field, value) => {
    let obj = { ...props.moduleInformation };
    obj.data[field] = value;
    props.changeModule(obj);
  };

  const changeDigitalUsage = (field, value) => {
    let obj = { ...props.moduleDigitalUsage };
    obj.data[field] = value;
    props.changeDigitalUsage(obj);
  };

  const changePurpose = (field, value) => {
    let obj = { ...props.modulePurpose };
    obj.data[field] = value;
    props.changePurpose(obj);
  };

  const changeResultSkill = (field, value) => {
    let obj = { ...props.moduleResultSkill };
    obj.data[field] = value;
    props.changeResultSkill(obj);
  };

  const changeEstimate = (field, value) => {
    let obj = { ...props.moduleEstimate };
    obj.data[field] = value;
    props.changeModuleEstimate(obj);
  };

  const showDeleteModal = () => {
    setDeleteConfimationOpen(!deleteConfimationOpen);
  };

  const deleteModule = () => {
    const id = props.match.params.id;
    props.deleteModule([id]);

    props.history.push(`/work/app/constructor/modules`);
  };

  const saveModuleHandler = async () => {
    const {
      moduleInformation,
      modulePurpose,
      moduleResultSkill,
      moduleDigitalUsage,
      moduleSchedule,
      moduleEstimate
    } = props;
    const id = props.match.params.id;

    const code = `М-${id}-20`;
    const module = {
      main: {
        code: code,
        name: moduleInformation.data.name,
        speciality: moduleInformation.data.speciality,
        skill: moduleInformation.data.skill,
        year: moduleInformation.data.year,
        educationForm: moduleInformation.data.educationForm,
        trialForm: moduleInformation.data.trialForm,
        description: moduleInformation.data.description
      },
      purpose: modulePurpose.data,
      resultSkill: moduleResultSkill.data,
      digitalUsage: moduleDigitalUsage.data,
      schedule: moduleSchedule.data,
      estimate: moduleEstimate.data
    };

    setSaveModule(true);

    await props.updateModule(id, module);
    await props.saveAllModuleSchedule();
    await props.getModuleCard(id);
  };

  const goBack = () => {
    props.history.goBack();
  };

  const {
    skils,
    specialities,
    moduleInformation,
    educationForm,
    trialForm,
    modulePurpose,
    moduleResultSkill,
    moduleDigitalUsage,
    moduleAbility,
    match,
    addModuleCardLogo,
    deleteModuleCardLogo,
    addModuleProgram,
    deleteModuleProgram,
    allModuleVolume,
    allModuleThemeVolume,
    allModuleAbilityTheme,
    allModuleLessonTheme,
    allLessonType,
    allResourceList,
    fetchingUpdateModuleInformation,
    isUpdatingProgram
  } = props;

  const isLarge = useMediaQuery({ minWidth: 1024 });
  const isSmall = useMediaQuery({ maxWidth: 774 });

  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [approveExpertiseModalOpen, setApproveExpertiseModalOpen] = useState(false);
  const [rejectExpertiseModalOpen, setRejectExpertiseModalOpen] = useState(false);
  const [developModalOpen, setDevelopModalOpen] = useState(false);
  const [publicationModalOpen, setPublicationModalOpen] = useState(false);
  const [approvePublicationModalOpen, setApprovePublicationModalOpen] = useState(false);
  const [rejectPublicationModalOpen, setRejectPublicationModalOpen] = useState(false);

  return (
    <div>
      <DeleteConfirmationModal
        open={deleteConfimationOpen}
        handleClose={showDeleteModal}
        modalText="Удалить модуль?"
        onConfirm={deleteModule}
      />
      <ApproveModal open={approveModalOpen}
                    programId={props.match.params.id}
                    handleClose={() => setApproveModalOpen(false)}
                    handleConfirm={props.sendProgramToExpertise}
                    reload={() => {
                      props.getModuleCard(props.match.params.id);
                      props.getModuleInformation(props.match.params.id);
                    }}
                    isLoading={isUpdatingProgram}
                    message="После отправки на экспертизу редактирование будет невозможно."
                    modalText="Отправить модуль на экспертизу?"/>
      <ApproveModal open={developModalOpen} programId={props.match.params.id}
                    handleClose={() => setDevelopModalOpen(false)}
                    handleConfirm={props.sendProgramToDevelop}
                    reload={() => {
                      props.getModuleCard(props.match.params.id);
                      props.getModuleInformation(props.match.params.id);
                    }}
                    isLoading={isUpdatingProgram}
                    modalText="Отправить модуль на доработку?"/>
      <ApproveModal open={approveExpertiseModalOpen} programId={props.match.params.id}
                    handleClose={() => setApproveExpertiseModalOpen(false)}
                    handleConfirm={props.approveProgramExpertise}
                    reload={() => {
                      props.getModuleCard(props.match.params.id);
                      props.getModuleInformation(props.match.params.id);
                    }}
                    isLoading={isUpdatingProgram}
                    modalText="Одобрить модуль?"/>
      <ApproveModal open={rejectExpertiseModalOpen} programId={props.match.params.id}
                    handleClose={() => setRejectExpertiseModalOpen(false)}
                    handleConfirm={props.rejectProgramExpertise}
                    reload={() => {
                      props.getModuleCard(props.match.params.id);
                      props.getModuleInformation(props.match.params.id);
                    }}
                    isLoading={isUpdatingProgram}
                    message="После отклонения модуль будет снята с экспертизы. Редактирование будет невозможно."
                    modalText="Отклонить модуль?"/>
      <ApproveModal open={publicationModalOpen} programId={props.match.params.id}
                    handleClose={() => setPublicationModalOpen(false)}
                    handleConfirm={props.sendProgramToPublication}
                    reload={() => {
                      props.getModuleCard(props.match.params.id);
                      props.getModuleInformation(props.match.params.id);
                    }}
                    isLoading={isUpdatingProgram}
                    modalText="Отправить модуль на публикацию?"/>
      <ApproveModal open={approvePublicationModalOpen} programId={props.match.params.id}
                    handleClose={() => setApprovePublicationModalOpen(false)}
                    handleConfirm={props.approveProgramPublication}
                    reload={() => {
                      props.getModuleCard(props.match.params.id);
                      props.getModuleInformation(props.match.params.id);
                    }}
                    isLoading={isUpdatingProgram}
                    message="После публикации модуль будет опубликован в каталоге."
                    modalText="Опубликовать модуль?"/>
      <ApproveModal open={rejectPublicationModalOpen} programId={props.match.params.id}
                    handleClose={() => setRejectPublicationModalOpen(false)}
                    handleConfirm={props.rejectProgramPublication}
                    reload={() => {
                      props.getModuleCard(props.match.params.id);
                      props.getModuleInformation(props.match.params.id);
                    }}
                    isLoading={isUpdatingProgram}
                    modalText="Отклонить публикацию модуля?"/>
      <Breadcrumbs items={items} />

      {moduleInformation.info ? (
        <div className={classes.content} style={{ width: isSmall && "100%" }}>
          <div className={classes.nav}>
            <Navbar
              statusId={moduleInformation.info.statusId}
              reload={() => {
                props.getModuleCard(props.match.params.id);
                props.getModuleInformation(props.match.params.id);
              }}
              showDeleteModal={showDeleteModal}
              goBack={goBack}
              saveModule={saveModuleHandler}
              sendToExpertise={() => setApproveModalOpen(true)}
              sendToDevelop={() => setDevelopModalOpen(true)}
              approveExpertise={() => setApproveExpertiseModalOpen(true)}
              rejectExpertise={() => setRejectExpertiseModalOpen(true)}
              sendToPublication={() => setPublicationModalOpen(true)}
              approvePublication={() => setApprovePublicationModalOpen(true)}
              rejectPublication={() => setRejectPublicationModalOpen(true)}
              isUpdating={fetchingUpdateModuleInformation || isUpdatingProgram}
              disabled={false}
              created={moduleInformation.info.created}
            />
          </div>
          <div className={classes.root}>
            <Tabs
              orientation={isSmall ? "horizontal" : "vertical"}
              items={tabitems}
            >
              <Box noMargin>
                <>
                {moduleInformation.info.statusId === 2 &&
                <Alert style={{marginBottom: "16px"}} severity="info">Редактирование невозможно. Модуль находится на экспертизе.</Alert>}
                {specialities && skils && educationForm && trialForm && (
                  <BasicInfo
                    disabled={moduleInformation.info.statusId != 1}
                    moduleInformation={moduleInformation}
                    specialities={specialities}
                    skils={skils}
                    educationForm={educationForm}
                    trialForm={trialForm}
                    change={changeModuleInformation}
                    addModuleCardLogo={addModuleCardLogo}
                    deleteModuleCardLogo={deleteModuleCardLogo}
                    addModuleProgram={addModuleProgram}
                    deleteModuleProgram={deleteModuleProgram}
                  />
                )}</>
              </Box>
              <Box noMargin>
                {modulePurpose.data && (
                  <Purpose
                    modulePurpose={modulePurpose}
                    change={changePurpose}
                  />
                )}
              </Box>
              <Box noMargin>
                {moduleResultSkill && (
                  <ResultSkill
                    moduleResultSkill={moduleResultSkill}
                    change={changeResultSkill}
                  />
                )}
              </Box>
              <Box noMargin>
                <ModuleRequirements
                  title="В результате освоения модуля слушатель должен:"
                  moduleAbility={moduleAbility}
                  matchId={match.params.id}
                />
              </Box>
              <Box noMargin>
                {moduleDigitalUsage.data && (
                  <DigitalTrainingMaterials
                    title="Формы использования цифровых учебных материалов"
                    moduleDigitalUsage={moduleDigitalUsage}
                    change={changeDigitalUsage}
                  />
                )}
              </Box>
              <Box noMargin>
                <ThematicPlan
                  title="Разделы учебно-тематического плана"
                  allModuleVolume={allModuleVolume}
                  allModuleThemeVolume={allModuleThemeVolume}
                  allModuleAbilityTheme={allModuleAbilityTheme}
                  allModuleLessonTheme={allModuleLessonTheme}
                  allLessonType={allLessonType}
                  allResourceList={allResourceList}
                />
              </Box>
              <Box noMargin>
                <TrainingProgram matchId={match.params.id} />
              </Box>
              <Box noMargin>
                <CalendarSchedule />
              </Box>
              <Box noMargin>
                <TechnicalConditions />
              </Box>
              <Box noMargin>
                <MainBooks />
              </Box>
              <Box noMargin>
                <AditionalBooks />
              </Box>
              <Box noMargin>
                <Periodicals />
              </Box>
              <Box noMargin>
                <ElectronicResource />
              </Box>
              <Box noMargin>
                <QualityControl change={changeEstimate} />
              </Box>
              <Box noMargin>
                <Compilers moduleId={match.params.id} />
              </Box>
            </Tabs>
          </div>
          {isLarge && (
            <InfoDrawer
              open={
                saveModule ||
                (moduleInformation.info && moduleInformation.info.created)
              }
            >
              <ModuleInfoDrawer moduleId={match.params.id} newModule />
            </InfoDrawer>
          )}
        </div>
      ) : (
        <div className={classes.progress}>
          <Progress />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  moduleInformation: state.modules.moduleInformation,
  specialities: state.specialities.specialities,
  skils: state.skill.skillAll,
  educationForm: state.modules.educationForm,
  trialForm: state.modules.trialForm,
  modulePurpose: state.modules.modulePurpose,
  moduleResultSkill: state.modules.moduleResultSkill,
  moduleDigitalUsage: state.modules.digitalUsage,
  moduleAbility: state.modules.moduleAbility,
  allModuleVolume: state.modules.allModuleVolume,
  allModuleThemeVolume: state.modules.allModuleThemeVolume,
  allModuleAbilityTheme: state.modules.allModuleAbilityTheme,
  allModuleLessonTheme: state.modules.allModuleLessonTheme,
  allLessonType: state.modules.allLessonType,
  allResourceList: state.modules.allResourceList,
  moduleSchedule: state.modules.moduleSchedule,
  moduleEstimate: state.modules.moduleEstimate,
  fetchingUpdateModuleInformation: state.modules.fetchingUpdateModuleInformation,
  isUpdatingProgram: state.programConstruct.isUpdatingProgram,
});

const mapDispatchToProps = dispatch => ({
  getModuleInformation: id => dispatch(getModuleInformationAction(id)),
  getSpecialitiesList: () => dispatch(getSpecialities()),
  getSkillList: () => dispatch(getSkillAllAction()),
  changeModule: module => dispatch(changeModuleInformationAction(module)),
  changePurpose: purpose => dispatch(changeModulePurposeAction(purpose)),
  changeResultSkill: resultSkill =>
    dispatch(changeModuleResultSkillAction(resultSkill)),
  changeDigitalUsage: digitalUsage =>
    dispatch(changeModuleDigitalUsageAction(digitalUsage)),
  getEducationForm: () => dispatch(getEducationFormAction()),
  getTrialForm: () => dispatch(getTrialFormAction()),
  updateModule: (id, module) =>
    dispatch(updateModuleInformationAction(id, module)),
  addNewModule: () => dispatch(addNewModuleInformationAction()),
  getModuleCard: id => dispatch(getModuleCardAction(id)),
  getModulePurpose: id => dispatch(getModulePurposeAction(id)),
  getModuleResultSkill: id => dispatch(getModuleResultSkillAction(id)),
  getModuleAbility: id => dispatch(getModuleAbilityAction(id)),
  deleteModule: idList => dispatch(deleteModuleAction(idList)),
  getModuleDigitalUsage: id => dispatch(getModuleDigitalUsageAction(id)),
  addModuleCardLogo: image => dispatch(addModuleCardLogoAction(image)),
  deleteModuleCardLogo: () => dispatch(deleteModuleCardLogoAction()),
  addModuleProgram: program => dispatch(addModuleProgramAction(program)),
  deleteModuleProgram: () => dispatch(deleteModuleProgramAction()),
  getAllModuleVolume: id => dispatch(getAllModuleVolumeAction(id)),
  getAllModuleThemeVolume: id => dispatch(getAllModuleThemeVolumeAction(id)),
  getAllModuleAbilityTheme: id => dispatch(getAllModuleAbilityThemeAction(id)),
  getAllModuleLessonTheme: id => dispatch(getAllModuleLessonThemeAction(id)),
  getAllLessonType: () => dispatch(getAllLessonTypeAction()),
  getAllResourceList: () => dispatch(getAllResourceListAction()),
  getAllRoomTypesList: () => dispatch(getAllRoomTypesListAction()),
  getAllModuleRoomList: id => dispatch(getAllModuleRoomListAction(id)),
  getAllResourceTypeList: () => dispatch(getAllResourceTypeListAction()),
  getAllModuleResourceList: id => dispatch(getAllModuleResourceListAction(id)),
  getAllModuleReferenceList: id =>
    dispatch(getAllModuleReferenceListAction(id)),
  getAllModuleSiteList: id => dispatch(getAllModuleSiteListAction(id)),
  getModuleSchedule: id => dispatch(getModuleScheduleAction(id)),
  saveAllModuleSchedule: () => dispatch(saveAllModuleScheduleAction()),
  getModuleEstimate: id => dispatch(getModuleEstimateAction(id)),
  changeModuleEstimate: estimate =>
    dispatch(changeModuleEstimateAction(estimate)),
  getAllModuleCriterionList: id =>
    dispatch(getAllModuleCriterionListAction(id)),
  getAllModuleCompilers: id => dispatch(getAllModuleCompilersAction(id)),
  getOrganizationsList: () => dispatch(getOrganizations()),
  sendProgramToExpertise: (id, comment) => dispatch(sendProgramToExpertise(id, comment)),
  sendProgramToPublication: (id, comment) => dispatch(sendProgramToPublication(id, comment)),
  sendProgramToDevelop: (id, comment) => dispatch(sendProgramToDevelop(id, comment)),
  approveProgramExpertise: (id, comment) => dispatch(approveProgramExpertise(id, comment)),
  approveProgramPublication: (id, comment) => dispatch(approveProgramPublication(id, comment)),
  rejectProgramExpertise: (id, comment) => dispatch(rejectProgramExpertise(id, comment)),
  rejectProgramPublication: (id, comment) => dispatch(rejectProgramPublication(id, comment))
});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleEdit);
